export default __webpack_public_path__ + "static/media/Transamerica Dark.38176e4b.svg";